export const formatNumber = (num: any) => {
  num = Number(num);
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M"; // For numbers >= 1M
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K"; // For numbers >= 1K and < 1M
  }
  return num.toLocaleString(); // For numbers < 1K, display with commas if necessary
};
